'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { pick } from 'underscore';
import { MODAL_TYPES } from 'DesignData/enums/FinderActionModalTypes';
import { openActionModal } from 'DesignData/actions/finder/Modals';
import * as finderSelectors from 'DesignData/selectors/finder';
import { getActiveLayoutId } from 'DesignData/selectors/app';
import { compose } from 'redux';

function WithActionsModals(WrappedComponent) {
  const HighOrderWithActionsModals = props => {
    const handleCreatePageClick = () => {
      props.openActionModal(MODAL_TYPES.CREATE_CONTENT);
    };

    const handleDeleteFolderClick = () => {
      props.openActionModal(MODAL_TYPES.DELETE_FOLDER);
    };

    const handleBulkDeleteClick = () => {
      props.openActionModal(MODAL_TYPES.BULK_DELETE);
    };

    const handleBulkMoveFileClick = () => {
      props.openActionModal(MODAL_TYPES.BULK_MOVE);
    };

    const handleDeleteClick = () => {
      props.openActionModal(MODAL_TYPES.DELETE);
    };

    const handleBulkPortalCopyClick = () => {
      props.openActionModal(MODAL_TYPES.BULK_PORTAL_COPY_WIZARD);
    };

    const handlePortalCopyClick = () => {
      props.openActionModal(MODAL_TYPES.PORTAL_COPY_WIZARD);
    };

    const handleMoveFileClick = () => {
      props.openActionModal(MODAL_TYPES.MOVE_ASSET);
    };

    const handleThemeDuplicateClick = () => {
      props.openActionModal(MODAL_TYPES.THEME_DUPLICATE);
    };

    const handleShowInformationClick = () => {
      props.openActionModal(MODAL_TYPES.SHOW_INFORMATION);
    };

    const handleAssetPortalCopyClick = () => {
      props.openActionModal(MODAL_TYPES.ASSET_PORTAL_COPY);
    };

    const handleCreateChildThemeClick = () => {
      props.openActionModal(MODAL_TYPES.CREATE_CHILD_THEME_WIZARD);
    };

    const handleChildThemeAddClick = () => {
      props.openActionModal(MODAL_TYPES.CHILD_THEME_ADD_WIZARD);
    };

    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      onDeleteFileClick: handleDeleteClick,
      onPortalCopyClick: handlePortalCopyClick,
      onMoveFileClick: handleMoveFileClick,
      onBulkDeleteClick: handleBulkDeleteClick,
      onBulkPortalCopyClick: handleBulkPortalCopyClick,
      onBulkMoveFileClick: handleBulkMoveFileClick,
      onDeleteFolderClick: handleDeleteFolderClick,
      onCreateContentClick: handleCreatePageClick,
      onShowInformationClick: handleShowInformationClick,
      onThemeDuplicateClick: handleThemeDuplicateClick,
      onAssetPortalCopyClick: handleAssetPortalCopyClick,
      onCreateChildThemeClick: handleCreateChildThemeClick,
      onChildThemeAddClick: handleChildThemeAddClick
    }));
  };

  HighOrderWithActionsModals.propTypes = {
    openActionModal: PropTypes.func.isRequired
  };
  return HighOrderWithActionsModals;
}

const mapDispatchToProps = {
  openActionModal
};

function makeMapStateToProps() {
  const getFileProps = finderSelectors.makeGetFileProps();
  const getFolderProps = finderSelectors.makeGetFolderProps();
  return function mapStateToProps(state, props) {
    const activeLayoutId = getActiveLayoutId(state, props);
    const fileProps = getFileProps(state, Object.assign({}, props, {
      layoutId: activeLayoutId
    }));
    const {
      folderId: __fileFolderId
    } = fileProps || {};
    const folderProps = getFolderProps(state, props);
    return Object.assign({}, pick(fileProps, 'fileId', 'file', 'fileTemplateType', 'fileName', 'fileType'), {}, pick(folderProps, 'folderId', 'folderName'), {
      folderId: __fileFolderId || props.folderId
    });
  };
}

export default compose(connect(makeMapStateToProps(), mapDispatchToProps), WithActionsModals);